import React from "react";
import { SportsbookContext } from "../../contexts";
export const WinningCelebration = () => {
    const { getIcon } = React.useContext(SportsbookContext);
    return (React.createElement("div", { style: {
            display: "flex",
            borderBottom: "1px solid rgb(55, 55, 55)",
            alignItems: "center",
            justifyContent: "space-between",
            paddingRight: "20px",
            zIndex: 1,
            gap: "15px"
        } },
        React.createElement("div", { style: { overflow: "hidden" } }, getIcon("winning-celebration")),
        React.createElement("div", null, getIcon("dk-main-logo"))));
};
//# sourceMappingURL=WinningCelebration.js.map